import React, { useState } from "react";
import { X } from "lucide-react";

const photos = [
  {
    src: "https://customer-assets.emergentagent.com/job_sonic-hub-81/artifacts/1yrdhu1b_IMG_2052%205.jpg",
    caption: "Notodden Blues Festival · 2023",
    credit: "© Roald Jungård",
    alt: "Otto Junior playing Stratocaster live",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_sonic-hub-81/artifacts/kacoux9r_IMG_3955%207.JPG",
    caption: "Springing The Blues · Jacksonville, Florida",
    credit: "Live · April 2026",
    alt: "Otto Junior Band at Springing The Blues Festival",
  },
  {
    src: "/band-pink.jpg",
    caption: "On Stage · Pink Lights",
    credit: "Otto Junior",
    alt: "Otto Junior under pink stage lights",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_sonic-hub-81/artifacts/7xiypaeq_IMG_2793%208.jpg",
    caption: "Live from South Korea · 2025",
    credit: "Otto Junior Band",
    alt: "Otto Junior Band on stage South Korea",
  },
];

export default function Pictures() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="pictures"
      data-testid="pictures-section"
      className="relative pt-14 md:pt-20 pb-4 md:pb-6 px-6 md:px-12 bg-vintage-bg"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-mono text-xs tracking-[0.35em] uppercase text-vintage-rust mb-4">
              / / From The Road
            </p>
            <h2 className="font-heading text-5xl md:text-7xl uppercase text-vintage-gold tracking-wide leading-none">
              Pictures
            </h2>
          </div>
          <p className="font-subheading italic text-vintage-cream/70 text-lg max-w-md">
            Stage lights, festivals, and crowds across three continents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 auto-rows-[260px] md:auto-rows-[320px]">
          {photos.map((p, idx) => {
            // Bento sizing
            const sizing =
              idx === 0
                ? "md:col-span-5 md:row-span-2"
                : idx === 1
                ? "md:col-span-7"
                : idx === 2
                ? "md:col-span-3"
                : "md:col-span-4";
            return (
              <button
                key={idx}
                type="button"
                data-testid={`pic-${idx}`}
                onClick={() => setActive(p)}
                className={`relative group overflow-hidden border border-vintage-cream/10 hover:border-vintage-rust/60 transition-colors bg-vintage-bg2 ${sizing}`}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{ filter: "contrast(1.04) saturate(0.95)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-vintage-bg/60 via-transparent to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity" />
              </button>
            );
          })}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          data-testid="pic-lightbox"
          className="fixed inset-0 z-[60] bg-vintage-bg/95 backdrop-blur-sm flex items-center justify-center p-6 md:p-12"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            data-testid="pic-lightbox-close"
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-vintage-cream hover:text-vintage-rust w-12 h-12 inline-flex items-center justify-center border border-vintage-cream/30"
            aria-label="Close"
          >
            <X size={22} />
          </button>
          <figure
            className="max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={active.src}
              alt={active.alt}
              className="w-full max-h-[80vh] object-contain"
            />
            <figcaption className="sr-only">
              {active.caption}
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}
